export var calendarEventStatus;
(function (calendarEventStatus) {
    calendarEventStatus["NEW"] = "NEW";
    calendarEventStatus["UPDATE"] = "UPDATE";
    calendarEventStatus["REMOVE"] = "REMOVE";
    calendarEventStatus["CANCEL"] = "CANCEL";
})(calendarEventStatus || (calendarEventStatus = {}));
export var conversationMfaOption;
(function (conversationMfaOption) {
    conversationMfaOption["ON"] = "ON";
    conversationMfaOption["AUTOMATIC"] = "AUTOMATIC";
    conversationMfaOption["OFF"] = "OFF";
})(conversationMfaOption || (conversationMfaOption = {}));
export var conversationType;
(function (conversationType) {
    conversationType["INTERNAL"] = "INTERNAL";
    conversationType["EXTERNAL"] = "EXTERNAL";
    conversationType["DIRECT"] = "DIRECT";
    conversationType["INBOX"] = "INBOX";
    conversationType["CHANNEL"] = "CHANNEL";
})(conversationType || (conversationType = {}));
export var conversationTypeInclArchived;
(function (conversationTypeInclArchived) {
    conversationTypeInclArchived["INTERNAL"] = "INTERNAL";
    conversationTypeInclArchived["EXTERNAL"] = "EXTERNAL";
    conversationTypeInclArchived["DIRECT"] = "DIRECT";
    conversationTypeInclArchived["INBOX"] = "INBOX";
    conversationTypeInclArchived["CHANNEL"] = "CHANNEL";
    conversationTypeInclArchived["ARCHIVED"] = "ARCHIVED";
})(conversationTypeInclArchived || (conversationTypeInclArchived = {}));
export var dataSourceType;
(function (dataSourceType) {
    dataSourceType["TRUTH"] = "TRUTH";
    dataSourceType["CLIENT_OPTIMISTIC"] = "CLIENT_OPTIMISTIC";
    dataSourceType["SERVER_OPTIMISTIC"] = "SERVER_OPTIMISTIC";
    dataSourceType["SUBSCRIPTION"] = "SUBSCRIPTION";
    dataSourceType["UPDATE_TIMEOUT"] = "UPDATE_TIMEOUT";
})(dataSourceType || (dataSourceType = {}));
export var globalSearchMatchType;
(function (globalSearchMatchType) {
    globalSearchMatchType["EVENT"] = "EVENT";
    globalSearchMatchType["FILE"] = "FILE";
    globalSearchMatchType["MESSAGE"] = "MESSAGE";
})(globalSearchMatchType || (globalSearchMatchType = {}));
export var linkPreviewResultStatus;
(function (linkPreviewResultStatus) {
    linkPreviewResultStatus["COMPLETE"] = "COMPLETE";
    linkPreviewResultStatus["INCOMPLETE"] = "INCOMPLETE";
})(linkPreviewResultStatus || (linkPreviewResultStatus = {}));
export var messageFlagType;
(function (messageFlagType) {
    messageFlagType["HAS_BLOBS"] = "HAS_BLOBS";
    messageFlagType["HAS_SMS"] = "HAS_SMS";
    messageFlagType["HAS_CALENDAR"] = "HAS_CALENDAR";
    messageFlagType["MARKETING_LEAD"] = "MARKETING_LEAD";
    messageFlagType["IS_AUTOMATED"] = "IS_AUTOMATED";
    messageFlagType["BLOBS_UPLOADED"] = "BLOBS_UPLOADED";
    messageFlagType["HAS_FOLDER"] = "HAS_FOLDER";
    messageFlagType["HAS_LIVING_FOLDER"] = "HAS_LIVING_FOLDER";
})(messageFlagType || (messageFlagType = {}));
export var messageSearchType;
(function (messageSearchType) {
    messageSearchType["SIMPLE"] = "SIMPLE";
    messageSearchType["ADVANCED"] = "ADVANCED";
})(messageSearchType || (messageSearchType = {}));
export var smsMetadataStatus;
(function (smsMetadataStatus) {
    smsMetadataStatus["PENDING"] = "PENDING";
    smsMetadataStatus["SENT"] = "SENT";
    smsMetadataStatus["DELIVERED"] = "DELIVERED";
    smsMetadataStatus["FAILED"] = "FAILED";
    smsMetadataStatus["FAILED_VALIDATION"] = "FAILED_VALIDATION";
    smsMetadataStatus["FAILED_LOOKUP"] = "FAILED_LOOKUP";
    smsMetadataStatus["FAILED_TWILIO"] = "FAILED_TWILIO";
})(smsMetadataStatus || (smsMetadataStatus = {}));
export var systemMessageType;
(function (systemMessageType) {
    systemMessageType["CONVERSATION_BEGIN"] = "CONVERSATION_BEGIN";
    systemMessageType["PARTICIPANT_LEFT"] = "PARTICIPANT_LEFT";
    systemMessageType["PARTICIPANT_JOIN"] = "PARTICIPANT_JOIN";
    systemMessageType["CONVERSATION_ARCHIVED"] = "CONVERSATION_ARCHIVED";
    systemMessageType["EMAIL_SENT"] = "EMAIL_SENT";
    systemMessageType["CONVERSATION_MFA_LOCKED"] = "CONVERSATION_MFA_LOCKED";
    systemMessageType["CONVERSATION_MFA_UNLOCKED"] = "CONVERSATION_MFA_UNLOCKED";
    systemMessageType["CHANNEL_VISIBILITY_CHANGE"] = "CHANNEL_VISIBILITY_CHANGE";
})(systemMessageType || (systemMessageType = {}));
export const fileRefDisplayFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'fileRefDisplayFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileRef' } },
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'messageUri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'filename' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'deleted' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'previewImage' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'previewPDF' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'originFileId' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'originFileVersionId' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'mfaOnlyRestricted' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'conversationUri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'senderUri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'creationTimestamp' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'isLivingFile' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'updated' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'previewUpdated' }, arguments: [], directives: [] },
                ],
            },
        },
    ],
};
export const globalSearchBlobFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'globalSearchBlobFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MessageBlobRef' } },
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'messageUri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'filename' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'size' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'sizeString' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'deleted' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'previewImage' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'previewPDF' }, arguments: [], directives: [] },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'previewCalendar' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'teamUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'externalRef' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizerUri' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'receiver' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'email' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'initials' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'externalRef' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'roleDisplay' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'staffAttendees' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'email' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'initials' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'externalRef' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'roleDisplay' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'teamUserUris' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'sequence' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'calendarEventUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'subject' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'location' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'start' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'end' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'timezone' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'timezoneIcsData' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'allDay' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'calendarEventRRULE' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRemoved' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'sentTimestamp' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'zoomMeetingId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'originFileId' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'originFileVersionId' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'isLivingFile' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'updated' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'previewUpdated' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'isFolder' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'modifiedTs' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'folderId' }, arguments: [], directives: [] },
                ],
            },
        },
    ],
};
export const globalSearchConversationFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'globalSearchConversationFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Conversation' } },
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'sharedConversationUri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'creationTimestamp' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'updateTimestamp' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'archived' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'dataSourceType' }, arguments: [], directives: [] },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bookmarkSummary' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'conversationTs' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'users' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'userUri' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'ts' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharedBookmarkSummary' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'users' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'userUri' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'ts' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'alias' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'value' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'displayDetail' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'displayId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'externalRef' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'lane' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'participants' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'active' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'user' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'initials' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'email' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'avatarImgUrl' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'stroke' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'fill' }, arguments: [], directives: [] },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'outOfOfficeEndDate' },
                                                arguments: [],
                                                directives: [],
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'outOfOfficeStartDate' },
                                                arguments: [],
                                                directives: [],
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'team' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'staffUri' }, arguments: [], directives: [] },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'mfaStatus' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'mfaEnabled' },
                                                            arguments: [],
                                                            directives: [],
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'conversationRoleExternalRef' },
                                    arguments: [],
                                    directives: [],
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conversationRoles' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'email' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'externalRef' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'firstName' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastName' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'initials' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'roleDisplay' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'active' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharedParticipants' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'active' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'originTeam' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'user' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'initials' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'avatarImgUrl' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'stroke' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'fill' }, arguments: [], directives: [] },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'team' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'mfaOnly' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'pinned' }, arguments: [], directives: [] },
                ],
            },
        },
    ],
};
export const messageBlobRefDisplayFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'messageBlobRefDisplayFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MessageBlobRef' } },
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'messageUri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'filename' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'size' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'sizeString' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'deleted' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'previewImage' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'previewPDF' }, arguments: [], directives: [] },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'previewCalendar' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'teamUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'externalRef' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizerUri' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'receiver' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'email' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'initials' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'externalRef' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'roleDisplay' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'staffAttendees' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'email' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'initials' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'externalRef' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'roleDisplay' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'teamUserUris' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'sequence' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'calendarEventUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'subject' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'location' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'start' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'end' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'timezone' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'timezoneIcsData' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'allDay' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'calendarEventRRULE' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRemoved' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'sentTimestamp' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'zoomMeetingId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'originFileId' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'originFileVersionId' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'isLivingFile' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'updated' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'previewUpdated' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'isFolder' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'modifiedTs' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'folderId' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'replicationOriginFileId' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'received' }, arguments: [], directives: [] },
                ],
            },
        },
    ],
};
export const messageBlobRefCommentsFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'messageBlobRefCommentsFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MessageBlobRef' } },
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'deleted' }, arguments: [], directives: [] },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'comments' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'deleted' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const messageDisplayFieldsWithoutReferencedMessageInceptionFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'messageDisplayFieldsWithoutReferencedMessageInception' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Message' } },
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'text' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'creationTimestamp' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'updateTimestamp' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'deleted' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'blobCount' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'blobCountWithFolders' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'dataSourceType' }, arguments: [], directives: [] },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sender' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conversation' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'blobs' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'messageBlobRefDisplayFields' },
                                    directives: [],
                                },
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'messageBlobRefCommentsFields' },
                                    directives: [],
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'folderBlobs' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'messageBlobRefDisplayFields' },
                                    directives: [],
                                },
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'messageBlobRefCommentsFields' },
                                    directives: [],
                                },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'folderBlobsNextModifiedTs' }, arguments: [], directives: [] },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'systemMessages' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'text' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'privateToMessageSender' },
                                    arguments: [],
                                    directives: [],
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'deleted' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'systemMessageType' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'dataSourceType' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'commentOn' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'filename' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'size' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'sizeString' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'messageUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'deleted' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'dataSourceType' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'flags' }, arguments: [], directives: [] },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'smsMetadata' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'messageUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'rawPhoneNumber' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'latestStatus' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'statusReason' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'statusChanges' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'status' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'timestamp' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'reason' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'dataSourceType' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'links' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'key' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'label' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'link' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'suppressPreview' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'automatedMessageType' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'exRefs' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'pinTs' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'visibleOnlyToUserUris' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'likeCount' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'likedByCurrentUser' }, arguments: [], directives: [] },
                ],
            },
        },
        ...messageBlobRefDisplayFieldsFragmentDoc.definitions,
        ...messageBlobRefCommentsFieldsFragmentDoc.definitions,
    ],
};
export const bookmarkSummaryFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'bookmarkSummaryFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BookmarkSummary' } },
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'conversationTs' }, arguments: [], directives: [] },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'users' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'userUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'ts' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const sharedBookmarkSummaryFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'sharedBookmarkSummaryFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SharedBookmarkSummary' } },
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'users' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'userUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'ts' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const aliasFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'aliasFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ConversationAlias' } },
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'value' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'displayDetail' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'displayId' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'externalRef' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'lane' }, arguments: [], directives: [] },
                ],
            },
        },
    ],
};
export const participantFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'participantFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ConversationParticipant' } },
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'active' }, arguments: [], directives: [] },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'firstName' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastName' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'initials' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'email' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'avatarImgUrl' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'stroke' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'fill' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'outOfOfficeEndDate' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'outOfOfficeStartDate' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'team' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'staffUri' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'mfaStatus' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'mfaEnabled' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conversationRoleExternalRef' },
                        arguments: [],
                        directives: [],
                    },
                ],
            },
        },
    ],
};
export const rolesFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'rolesFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ConversationRole' } },
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'email' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'externalRef' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'firstName' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'lastName' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'initials' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'roleDisplay' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'active' }, arguments: [], directives: [] },
                ],
            },
        },
    ],
};
export const sharedParticipantFragmentFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'sharedParticipantFragment' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SharedConversationParticipant' } },
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'active' }, arguments: [], directives: [] },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'originTeam' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'firstName' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastName' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'initials' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'avatarImgUrl' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'stroke' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'fill' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'email' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'team' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const conversationDisplayFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'conversationDisplayFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Conversation' } },
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'sharedConversationUri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'creationTimestamp' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'updateTimestamp' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'archived' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'type' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'dataSourceType' }, arguments: [], directives: [] },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bookmarkSummary' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'bookmarkSummaryFragment' }, directives: [] },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharedBookmarkSummary' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'sharedBookmarkSummaryFragment' },
                                    directives: [],
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'alias' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'aliasFragment' }, directives: [] }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'participants' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'participantFragment' }, directives: [] },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conversationRoles' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'rolesFragment' }, directives: [] }],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharedParticipants' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'sharedParticipantFragment' }, directives: [] },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'mfaOnly' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'description' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'pinned' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'restricted' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'ownerUri' }, arguments: [], directives: [] },
                ],
            },
        },
        ...bookmarkSummaryFragmentFragmentDoc.definitions,
        ...sharedBookmarkSummaryFragmentFragmentDoc.definitions,
        ...aliasFragmentFragmentDoc.definitions,
        ...participantFragmentFragmentDoc.definitions,
        ...rolesFragmentFragmentDoc.definitions,
        ...sharedParticipantFragmentFragmentDoc.definitions,
    ],
};
export const messageDisplayFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'messageDisplayFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Message' } },
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'messageDisplayFieldsWithoutReferencedMessageInception' },
                        directives: [],
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'referencedMessage' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'messageDisplayFieldsWithoutReferencedMessageInception' },
                                    directives: [],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'conversation' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'conversationDisplayFields' },
                                                directives: [],
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageDisplayFieldsWithoutReferencedMessageInceptionFragmentDoc.definitions,
        ...conversationDisplayFieldsFragmentDoc.definitions,
    ],
};
export const messageDisplayFieldsWithoutConversationFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'messageDisplayFieldsWithoutConversation' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Message' } },
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'messageDisplayFieldsWithoutReferencedMessageInception' },
                        directives: [],
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'referencedMessage' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'messageDisplayFieldsWithoutReferencedMessageInception' },
                                    directives: [],
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageDisplayFieldsWithoutReferencedMessageInceptionFragmentDoc.definitions,
    ],
};
export const portalBlobRefDisplayFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'portalBlobRefDisplayFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PortalBlobRef' } },
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'messageUri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'filename' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'deleted' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'thumbnail' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'previewImage' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'previewPDF' }, arguments: [], directives: [] },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'previewCalendar' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'teamUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'externalRef' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'organizerUri' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'receiver' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'email' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'initials' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'externalRef' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'roleDisplay' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'staffAttendees' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'email' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'initials' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'externalRef' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'roleDisplay' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'teamUserUris' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'sequence' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'calendarEventUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'subject' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'location' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'start' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'end' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'timezone' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'timezoneIcsData' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'allDay' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'calendarEventRRULE' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'isRemoved' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'sentTimestamp' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'zoomMeetingId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'originFileId' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'originFileVersionId' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'mfaOnlyRestricted' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'isFolder' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'isLivingFile' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'updated' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'previewUpdated' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'openedTs' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'unread' }, arguments: [], directives: [] },
                ],
            },
        },
    ],
};
export const remindMeDisplayFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'remindMeDisplayFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RemindMe' } },
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'messageUri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'remindAt' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'deleted' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'dataSourceType' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                ],
            },
        },
    ],
};
export const userDisplayFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'userDisplayFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'firstName' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'lastName' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'email' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'initials' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'avatarImgUrl' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'dataSourceType' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'fill' }, arguments: [], directives: [] },
                    { kind: 'Field', name: { kind: 'Name', value: 'stroke' }, arguments: [], directives: [] },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'notificationPrefs' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'key' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'value' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'uiPrefs' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'key' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'value' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mfaStatus' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'mfaEnabled' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'mfaRescueEnabled' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sidebarSublistCollapse' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'INTERNAL' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'EXTERNAL' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'DIRECT' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'INBOX' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'CHANNEL' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'ARCHIVED' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const userRecentConversationDisplayFieldsFragmentDoc = {
    kind: 'Document',
    definitions: [
        {
            kind: 'FragmentDefinition',
            name: { kind: 'Name', value: 'userRecentConversationDisplayFields' },
            typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UserRecentConversationUris' } },
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conversationUriGroups' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'DIRECT' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'INTERNAL' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'EXTERNAL' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'INBOX' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'CHANNEL' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pinnedConversationUriGroups' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'DIRECT' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'INTERNAL' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'EXTERNAL' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'INBOX' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'CHANNEL' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                    { kind: 'Field', name: { kind: 'Name', value: 'archivedUris' }, arguments: [], directives: [] },
                ],
            },
        },
    ],
};
export const addConversationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'addConversation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ConversationType' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'alias' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'displayDetail' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'displayId' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'teamUserUris' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                        },
                    },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'externalRoles' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: {
                                kind: 'NonNullType',
                                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ConversationRoleInput' } },
                            },
                        },
                    },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'externalRef' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'mfaOption' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'ConversationMfaOption' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'restricted' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'addConversation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'type' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'alias' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'alias' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'displayDetail' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'displayDetail' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'displayId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'displayId' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'teamUserUris' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'teamUserUris' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'externalRoles' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'externalRoles' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'externalRef' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'externalRef' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'mfaOption' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'mfaOption' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'description' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'restricted' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'restricted' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const addConversationWithMessageDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'addConversationWithMessage' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'conversation' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ConversationWithMessageConversationInput' } },
                    },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'message' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'ConversationWithMessageMessageInput' } },
                    },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'addConversationWithMessage' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversation' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'conversation' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'message' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'message' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const addFilesToConversationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'addFilesToConversation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageText' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'files' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: {
                                kind: 'NonNullType',
                                type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddFilesToConversationFileInput' } },
                            },
                        },
                    },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'addFilesToConversation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'messageText' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'messageText' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'files' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'files' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageDisplayFieldsFragmentDoc.definitions,
    ],
};
export const addMessageDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'addMessage' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'commentOnUri' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'flags' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'MessageFlagType' } },
                        },
                    },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'creationTimestamp' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'blobCount' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'smsMetadata' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SMSMetadataInput' } },
                        },
                    },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'tempFileKeys' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'addMessage' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'text' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'uri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'commentOnUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'commentOnUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'flags' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'flags' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'creationTimestamp' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'creationTimestamp' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'blobCount' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'blobCount' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'smsMetadata' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'smsMetadata' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'tempFileKeys' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'tempFileKeys' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageDisplayFieldsFragmentDoc.definitions,
    ],
};
export const addMessageBlobRefDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'addMessageBlobRef' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'filename' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'size' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'originId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'sizeString' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'addMessageBlobRef' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'uri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'messageUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'filename' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'filename' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'size' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'size' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'originId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'originId' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'sizeString' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'sizeString' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'messageBlobRefDisplayFields' },
                                    directives: [],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'message' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageBlobRefDisplayFieldsFragmentDoc.definitions,
    ],
};
export const archieComplementDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'archieComplement' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'originalMessage' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'promptKey' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'archieComplement' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'originalMessage' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'originalMessage' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'promptKey' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'promptKey' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'content' }, arguments: [], directives: [] }],
                        },
                    },
                ],
            },
        },
    ],
};
export const archiveConversationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'archiveConversation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'archiveConversation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'uri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const autoLogoutUpdateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'autoLogoutUpdate' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'autoLogoutUpdate' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'userUri' }, arguments: [], directives: [] }],
                        },
                    },
                ],
            },
        },
    ],
};
export const badSearchDontUseDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'badSearchDontUse' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'badSearchDontUse' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'conversationDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...conversationDisplayFieldsFragmentDoc.definitions,
    ],
};
export const portalBlobRefDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'portalBlobRef' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portalBlobRef' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'uri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'portalBlobRefDisplayFields' }, directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'conversationUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'creationTimestamp' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastEvaluatedKey' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'openedTs' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'senderUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'unread' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'pinTs' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...portalBlobRefDisplayFieldsFragmentDoc.definitions,
    ],
};
export const blobRefUpdateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'blobRefUpdate' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'blobRefUpdate' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'messageBlobRefDisplayFields' },
                                    directives: [],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'message' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'conversationUri' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageBlobRefDisplayFieldsFragmentDoc.definitions,
    ],
};
export const blobsFromFolderDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'blobsFromFolder' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'folderOriginFileId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'lteModifiedTs' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'blobsFromFolder' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'folderOriginFileId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'folderOriginFileId' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'messageUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'lteModifiedTs' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'lteModifiedTs' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'blobs' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'messageBlobRefDisplayFields' },
                                                directives: [],
                                            },
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'messageBlobRefCommentsFields' },
                                                directives: [],
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'nextModifiedTs' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageBlobRefDisplayFieldsFragmentDoc.definitions,
        ...messageBlobRefCommentsFieldsFragmentDoc.definitions,
    ],
};
export const blobsFromOriginFileIdDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'blobsFromOriginFileId' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'originFileId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'blobsFromOriginFileId' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'originFileId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'originFileId' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'originFileId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'originFileVersionId' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'message' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'creationTimestamp' },
                                                arguments: [],
                                                directives: [],
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sender' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'firstName' },
                                                            arguments: [],
                                                            directives: [],
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' }, arguments: [], directives: [] },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'conversation' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'conversationDisplayFields' },
                                                            directives: [],
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...conversationDisplayFieldsFragmentDoc.definitions,
    ],
};
export const bookmarkSummaryUpdateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'bookmarkSummaryUpdate' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bookmarkSummaryUpdate' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'bookmarkSummaryFragment' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...bookmarkSummaryFragmentFragmentDoc.definitions,
    ],
};
export const bumpBookmarkDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'bumpBookmark' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'selectedConversation' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'timestamp' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bumpBookmark' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'selectedConversation' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'timestamp' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'timestamp' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const canAccessConversationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'canAccessConversation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'canAccessConversation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'uri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                            },
                        ],
                        directives: [],
                    },
                ],
            },
        },
    ],
};
export const channelsSummaryDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'channelsSummary' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'channelsSummary' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'channels' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'alias' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'archived' }, arguments: [], directives: [] },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'conversationUri' },
                                                arguments: [],
                                                directives: [],
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'members' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const channelsSummaryUpdateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'channelsSummaryUpdate' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'channelsSummaryUpdate' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'channels' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'alias' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'archived' }, arguments: [], directives: [] },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'conversationUri' },
                                                arguments: [],
                                                directives: [],
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'members' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const commentsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'comments' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'commentOnUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'comments' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'commentOnUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'commentOnUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'text' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'creationTimestamp' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'updateTimestamp' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'blobCount' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'deleted' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'dataSourceType' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sender' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'conversation' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'commentOn' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'messageUri' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'filename' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'size' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'sizeString' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'deleted' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'dataSourceType' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'flags' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'links' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'key' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'label' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'link' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const conversationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'conversation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'selectedConversation' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conversation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'uri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'selectedConversation' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'conversationDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...conversationDisplayFieldsFragmentDoc.definitions,
    ],
};
export const conversationFromMagicLinkDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'conversationFromMagicLink' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'magicLink' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conversationFromMagicLink' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'magicLink' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'magicLink' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'conversationDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...conversationDisplayFieldsFragmentDoc.definitions,
    ],
};
export const conversationMessageUpdatesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'conversationMessageUpdates' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'selectedConversation' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conversationMessageUpdates' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'selectedConversation' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'after' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'before' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageDisplayFieldsFragmentDoc.definitions,
    ],
};
export const conversationMessagesWithBlobsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'conversationMessagesWithBlobs' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'selectedConversation' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conversationMessagesWithBlobs' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'selectedConversation' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageDisplayFieldsFragmentDoc.definitions,
    ],
};
export const conversationSubmissionRequestStatusDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'conversationSubmissionRequestStatus' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'selectedConversation' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conversationSubmissionRequestStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'selectedConversation' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageDisplayFieldsFragmentDoc.definitions,
    ],
};
export const conversationSubmissionStatusMessageUpdateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'conversationSubmissionStatusMessageUpdate' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conversationSubmissionStatusMessageUpdate' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageDisplayFieldsFragmentDoc.definitions,
    ],
};
export const conversationUpdateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'conversationUpdate' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conversationUpdate' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'conversationDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...conversationDisplayFieldsFragmentDoc.definitions,
    ],
};
export const conversationSummariesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'conversationSummaries' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'selectedConversation' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conversationSummaries' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'selectedConversation' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageDisplayFieldsFragmentDoc.definitions,
    ],
};
export const conversationSummaryMessageUpdateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'conversationSummaryMessageUpdate' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conversationSummaryMessageUpdate' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageDisplayFieldsFragmentDoc.definitions,
    ],
};
export const conversationsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'conversations' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'externalRef' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'conversations' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'externalRef' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'externalRef' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'conversationDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...conversationDisplayFieldsFragmentDoc.definitions,
    ],
};
export const deleteBlobRefDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'deleteBlobRef' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deleteBlobRef' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'uri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'messageUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'messageBlobRefDisplayFields' },
                                    directives: [],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'message' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageBlobRefDisplayFieldsFragmentDoc.definitions,
    ],
};
export const deleteMessageDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'deleteMessage' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deleteMessage' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'uri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageDisplayFieldsFragmentDoc.definitions,
    ],
};
export const deleteRemindMeDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'deleteRemindMe' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'deleteRemindMe' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'messageUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'remindMeDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...remindMeDisplayFieldsFragmentDoc.definitions,
    ],
};
export const doneTaskUpdateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'doneTaskUpdate' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'doneTaskUpdate' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'taskUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'taskType' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'doneTs' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const entityUrisAssociatedWithOperationIdDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'entityUrisAssociatedWithOperationId' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'operationId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entityUrisAssociatedWithOperationId' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'operationId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'operationId' } },
                            },
                        ],
                        directives: [],
                    },
                ],
            },
        },
    ],
};
export const exportConversationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'exportConversation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'timezone' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exportConversation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'timezone' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'timezone' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const externalRefPermissionsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'externalRefPermissions' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'externalRef' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'userUris' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                        },
                    },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'externalRefPermissions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'externalRef' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'externalRef' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'userUris' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'userUris' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'externalRef' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'userUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'canAccess' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const fileSearchDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'fileSearch' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchString' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fileSearch' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'searchString' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchString' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'fileRefDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...fileRefDisplayFieldsFragmentDoc.definitions,
    ],
};
export const getExternalUserMetadataDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getExternalUserMetadata' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'getExternalUserMetadata' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'email' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'lastLoginTs' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const getMessageContextDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getMessageContext' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'selectedConversation' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limitBefore' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limitAfter' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'getMessageContext' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'selectedConversation' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'messageUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limitBefore' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limitBefore' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limitAfter' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limitAfter' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageDisplayFieldsFragmentDoc.definitions,
    ],
};
export const globalSearchDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'globalSearch' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchText' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'matchType' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'GlobalSearchMatchType' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'startIndex' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'conversationTypes' } },
                    type: {
                        kind: 'ListType',
                        type: {
                            kind: 'NonNullType',
                            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ConversationType' } },
                        },
                    },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'matterUri' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'globalSearch' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'searchText' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchText' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'matchType' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'matchType' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'startIndex' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'startIndex' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationTypes' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'conversationTypes' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'matterUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'matterUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'total' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'showing' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hits' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'innerHitType' }, arguments: [], directives: [] },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'highlights' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'field' }, arguments: [], directives: [] },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'snippet' }, arguments: [], directives: [] },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'timestamp' }, arguments: [], directives: [] },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'blob' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'globalSearchBlobFields' },
                                                            directives: [],
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'conversation' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'globalSearchConversationFields' },
                                                            directives: [],
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'message' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'messageDisplayFields' },
                                                            directives: [],
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...globalSearchBlobFieldsFragmentDoc.definitions,
        ...globalSearchConversationFieldsFragmentDoc.definitions,
        ...messageDisplayFieldsFragmentDoc.definitions,
    ],
};
export const intercomUserHashDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'intercomUserHash' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'intercomUserHash' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hash' }, arguments: [], directives: [] }],
                        },
                    },
                ],
            },
        },
    ],
};
export const joinConversationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'joinConversation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'joinConversation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const leaveConversationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'leaveConversation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'leaveConversation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const linkPreviewDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'linkPreview' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'href' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'linkPreview' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'href' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'href' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'href' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'queryState' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'imageLocation' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'faviconLocation' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const messageSearchDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'messageSearch' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchText' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchFilter' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'MessageSearchFilter' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchType' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'MessageSearchType' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'startIndex' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageSearch' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'searchText' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchText' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'searchFilter' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchFilter' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'searchType' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchType' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'startIndex' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'startIndex' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'found' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'nextStart' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'timems' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'suppressedCount' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'hits' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'messageUri' }, arguments: [], directives: [] },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'creationTimestamp' },
                                                arguments: [],
                                                directives: [],
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'conversation' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'FragmentSpread',
                                                            name: { kind: 'Name', value: 'conversationDisplayFields' },
                                                            directives: [],
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'highlights' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'label' }, arguments: [], directives: [] },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'highlight' },
                                                            arguments: [],
                                                            directives: [],
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...conversationDisplayFieldsFragmentDoc.definitions,
    ],
};
export const messageUpdateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'messageUpdate' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageUpdate' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageDisplayFieldsFragmentDoc.definitions,
    ],
};
export const messagesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'messages' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'selectedConversation' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'lastCreationTimestamp' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messages' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'selectedConversation' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'lastCreationTimestamp' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'lastCreationTimestamp' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageDisplayFieldsFragmentDoc.definitions,
    ],
};
export const operationDoneDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'operationDone' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'operationDone' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'operationInfoJson' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const parentFoldersDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'parentFolders' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'blobUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'parentFolders' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'blobUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'blobUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'messageUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'blobs' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'messageBlobRefDisplayFields' },
                                                directives: [],
                                            },
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'messageBlobRefCommentsFields' },
                                                directives: [],
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageBlobRefDisplayFieldsFragmentDoc.definitions,
        ...messageBlobRefCommentsFieldsFragmentDoc.definitions,
    ],
};
export const pinConversationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'pinConversation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pinConversation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'uri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const pinnedConversationMessagesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'pinnedConversationMessages' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'selectedConversation' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pinnedConversationMessages' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'selectedConversation' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageDisplayFieldsFragmentDoc.definitions,
    ],
};
export const portalBillingInformationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'portalBillingInformation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portalBillingInformation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'teamUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'billingWidgetEnabled' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'eInvoiceEnabled' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'matters' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'matterId' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'unpaid' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'description' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'matterNumber' }, arguments: [], directives: [] },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'latestInvoiceDueDate' },
                                                arguments: [],
                                                directives: [],
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'invoicePaymentUrl' },
                                                arguments: [],
                                                directives: [],
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'hasSingleDebtorInvoices' },
                                                arguments: [],
                                                directives: [],
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'hasMultiDebtorInvoices' },
                                                arguments: [],
                                                directives: [],
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'eInvoice' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'url' }, arguments: [], directives: [] },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'eInvoiceId' },
                                                            arguments: [],
                                                            directives: [],
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'pdfInvoice' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'url' }, arguments: [], directives: [] },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'unread' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const portalBlobSearchDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'portalBlobSearch' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchText' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portalBlobSearch' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'searchText' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchText' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'teamUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'portalBlobRefDisplayFields' }, directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'conversationUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'creationTimestamp' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...portalBlobRefDisplayFieldsFragmentDoc.definitions,
    ],
};
export const portalBlobsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'portalBlobs' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'lastEvaluatedKey' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'sortKey' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portalBlobs' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'teamUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'lastEvaluatedKey' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'lastEvaluatedKey' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'sortKey' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'sortKey' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'portalBlobRefDisplayFields' }, directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'conversationUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'creationTimestamp' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastEvaluatedKey' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'openedTs' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'senderUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'pinTs' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...portalBlobRefDisplayFieldsFragmentDoc.definitions,
    ],
};
export const portalBlobsOpenedUnopenedDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'portalBlobsOpenedUnopened' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portalBlobsOpenedUnopened' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'teamUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'opened' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'portalBlobRefDisplayFields' },
                                                directives: [],
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'conversationUri' },
                                                arguments: [],
                                                directives: [],
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'creationTimestamp' },
                                                arguments: [],
                                                directives: [],
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'openedTs' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'unopened' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'portalBlobRefDisplayFields' },
                                                directives: [],
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'conversationUri' },
                                                arguments: [],
                                                directives: [],
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'creationTimestamp' },
                                                arguments: [],
                                                directives: [],
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'openedTs' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...portalBlobRefDisplayFieldsFragmentDoc.definitions,
    ],
};
export const portalCommentsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'portalComments' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'commentOnUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'lastCreationTimestamp' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portalComments' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'commentOnUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'commentOnUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'lastCreationTimestamp' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'lastCreationTimestamp' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageDisplayFieldsFragmentDoc.definitions,
    ],
};
export const portalConversationsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'portalConversations' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portalConversations' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'teamUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'conversationDisplayFields' }, directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'latestMessage' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'messageDisplayFieldsWithoutConversation' },
                                                directives: [],
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...conversationDisplayFieldsFragmentDoc.definitions,
        ...messageDisplayFieldsWithoutConversationFragmentDoc.definitions,
    ],
};
export const portalExternalTaskUpdateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'portalExternalTaskUpdate' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portalExternalTaskUpdate' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'teamUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'userUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'matterUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'providerId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'externalUserId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'url' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'sentTs' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'mfaOnly' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'optional' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'actionText' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'cancelledText' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'cancelledTs' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'cancelledUrl' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'completedText' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'completedTs' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'completedUrl' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'expiredText' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'expiredTs' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'expiredUrl' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const portalExternalTasksDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'portalExternalTasks' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portalExternalTasks' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'teamUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'teamUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'userUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'matterUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'providerId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'externalUserId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'url' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'sentTs' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'mfaOnly' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'optional' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'actionText' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'cancelledText' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'cancelledTs' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'cancelledUrl' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'completedText' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'completedTs' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'completedUrl' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'expiredText' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'expiredTs' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'expiredUrl' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const portalIntakeFormsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'portalIntakeForms' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portalIntakeForms' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'teamUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'completed' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'id' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'matterId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'status' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'title' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'url' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'unread' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const portalMattersDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'portalMatters' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portalMatters' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'teamUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'teamUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'matterUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'description' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'originatingStaffId' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'personAssistingStaffId' },
                                    arguments: [],
                                    directives: [],
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'personResponsibleStaffId' },
                                    arguments: [],
                                    directives: [],
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'supervisorStaffId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'dataSourceType' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const portalMessagesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'portalMessages' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'selectedConversation' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'lastCreationTimestamp' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portalMessages' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'selectedConversation' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'lastCreationTimestamp' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'lastCreationTimestamp' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageDisplayFieldsFragmentDoc.definitions,
    ],
};
export const portalRecentMessagesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'portalRecentMessages' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portalRecentMessages' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'teamUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'messageDisplayFields' }, directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sender' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'userDisplayFields' }, directives: [] },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageDisplayFieldsFragmentDoc.definitions,
        ...userDisplayFieldsFragmentDoc.definitions,
    ],
};
export const portalTeamsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'portalTeams' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portalTeams' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'members' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' }, arguments: [], directives: [] },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'outOfOfficeStartDate' },
                                                arguments: [],
                                                directives: [],
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'outOfOfficeEndDate' },
                                                arguments: [],
                                                directives: [],
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'email' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'phone' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'areaCode' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'number' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'streetAddress' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'buildingLevel' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'unitNumber' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'unitType' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'streetNumber' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'streetName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'streetType' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'city' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'state' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'zipCode' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'county' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'locality' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'country' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'careOf' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'poBoxType' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'poBoxNumber' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'mailingAddress' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'buildingLevel' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'unitNumber' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'unitType' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'streetNumber' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'streetName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'streetType' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'city' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'state' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'zipCode' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'county' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'locality' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'country' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'careOf' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'poBoxType' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'poBoxNumber' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'branding' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'color' }, arguments: [], directives: [] },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'headerTextColor' },
                                                arguments: [],
                                                directives: [],
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'area' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'logo' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const portalUpcomingEventsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'portalUpcomingEvents' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventStartFromTs' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portalUpcomingEvents' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'teamUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'eventStartFromTs' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventStartFromTs' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'limit' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'portalBlobRefDisplayFields' },
                                    directives: [],
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'conversationUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'creationTimestamp' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastEvaluatedKey' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...portalBlobRefDisplayFieldsFragmentDoc.definitions,
    ],
};
export const removeLinkPreviewDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'removeLinkPreview' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'href' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'removeLinkPreview' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'messageUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'href' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'href' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const removeRecentConversationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'removeRecentConversation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'removeRecentConversation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const retryMessageBlobUploadsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'retryMessageBlobUploads' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'blobRefUris' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'retryMessageBlobUploads' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'messageUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'blobRefUris' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'blobRefUris' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'operationInfoJson' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'requestTimestamp' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const sendFirmInsightsPdfReportDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'sendFirmInsightsPdfReport' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sendFirmInsightsPdfReport' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const setBlobRefPinnedValueDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'setBlobRefPinnedValue' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'blobRefUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'pinned' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'setBlobRefPinnedValue' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'blobRefUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'blobRefUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pinned' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'pinned' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const setIgnoreAutomatedMessageTypeDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'setIgnoreAutomatedMessageType' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'automatedMessageType' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'ignored' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'setIgnoreAutomatedMessageType' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'automatedMessageType' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'automatedMessageType' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'ignored' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'ignored' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const setMessageLikedDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'setMessageLiked' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'liked' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'setMessageLiked' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'messageUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'liked' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'liked' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const setMessagePinnedValueDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'setMessagePinnedValue' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'pinned' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'setMessagePinnedValue' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'messageUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pinned' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'pinned' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const sharedBookmarkSummaryUpdateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'sharedBookmarkSummaryUpdate' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sharedBookmarkSummaryUpdate' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'sharedBookmarkSummaryFragment' },
                                    directives: [],
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...sharedBookmarkSummaryFragmentFragmentDoc.definitions,
    ],
};
export const storeUserFeedbackDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'storeUserFeedback' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'feedbackType' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'storeUserFeedback' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'feedbackType' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'feedbackType' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'payload' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
                            },
                        ],
                        directives: [],
                    },
                ],
            },
        },
    ],
};
export const submissionStatusConversationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'submissionStatusConversation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submissionStatusConversation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'requestTimestamp' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const summariseConversationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'summariseConversation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summariseConversation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'requestTimestamp' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const syncExternalTaskProviderMappingsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'syncExternalTaskProviderMappings' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'externalTaskUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'syncExternalTaskProviderMappings' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'externalTaskUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'externalTaskUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'teamUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const syncLivingFilesWithLatestVersionsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'syncLivingFilesWithLatestVersions' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'files' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: {
                                kind: 'NonNullType',
                                type: { kind: 'NamedType', name: { kind: 'Name', value: 'SyncLivingFileWithLatestVersionInput' } },
                            },
                        },
                    },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'syncLivingFilesWithLatestVersions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'files' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'files' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'originFileUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'newVersionFound' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'newVersionUpdated' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const syncLivingFolderFilesWithLatestVersionsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'syncLivingFolderFilesWithLatestVersions' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'folder' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'SyncLivingFolderFilesWithLatestVersionsInput' } },
                    },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'syncLivingFolderFilesWithLatestVersions' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'folder' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'folder' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'blobRefUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'originFileUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'newVersionFound' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'newVersionUpdated' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const teamDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'team' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'team' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'name' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'members' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' }, arguments: [], directives: [] },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'outOfOfficeStartDate' },
                                                arguments: [],
                                                directives: [],
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'outOfOfficeEndDate' },
                                                arguments: [],
                                                directives: [],
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'branding' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'enabled' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'color' }, arguments: [], directives: [] },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'headerTextColor' },
                                                arguments: [],
                                                directives: [],
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'area' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'logo' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'email' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'phone' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'areaCode' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'number' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'streetAddress' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'buildingLevel' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'unitNumber' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'unitType' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'streetNumber' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'streetName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'streetType' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'city' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'state' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'zipCode' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'county' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'locality' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'country' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'careOf' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'poBoxType' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'poBoxNumber' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'templates' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'newMessage' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'subject' }, arguments: [], directives: [] },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'body' }, arguments: [], directives: [] },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'introduction' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'subject' }, arguments: [], directives: [] },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'body' }, arguments: [], directives: [] },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const teamSettingsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'teamSettings' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'teamSettings' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'key' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'value' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const unarchiveConversationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'unarchiveConversation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'unarchiveConversation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'uri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const unlinkConversationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'unlinkConversation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'unlinkConversation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'uri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const unpinConversationDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'unpinConversation' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'unpinConversation' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'uri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const updateChannelVisibilityDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'updateChannelVisibility' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'restricted' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateChannelVisibility' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'restricted' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'restricted' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const updateClientPortalBrandingDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'updateClientPortalBranding' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'enabled' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'color' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'headerTextColor' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'area' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'logo' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateClientPortalBranding' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'enabled' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'enabled' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'color' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'color' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'headerTextColor' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'headerTextColor' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'area' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'area' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'logo' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'logo' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'requestTimestamp' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const updateClientPortalEmailTemplateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'updateClientPortalEmailTemplate' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'subject' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'body' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateClientPortalEmailTemplate' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'type' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'subject' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'subject' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'body' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'body' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'requestTimestamp' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const updateConversationAliasDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'updateConversationAlias' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'alias' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'displayDetail' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'displayId' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'externalRef' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'ConversationType' } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateConversationAlias' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'alias' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'alias' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'displayDetail' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'displayDetail' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'displayId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'displayId' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'externalRef' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'externalRef' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'type' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const updateConversationDescriptionDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'updateConversationDescription' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateConversationDescription' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'description' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const updateConversationMfaOnlyStatusDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'updateConversationMfaOnlyStatus' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'mfaOnly' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateConversationMfaOnlyStatus' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'uri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'mfaOnly' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'mfaOnly' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const updateConversationParticipantsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'updateConversationParticipants' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'teamUserUris' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                        },
                    },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'externalRoles' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: {
                                kind: 'NonNullType',
                                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ConversationRoleInput' } },
                            },
                        },
                    },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateConversationParticipants' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'teamUserUris' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'teamUserUris' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'externalRoles' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'externalRoles' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const updateRemindMeDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'updateRemindMe' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'remindMeInMinutes' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'remindmeAtEpochTs' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateRemindMe' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'messageUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'remindMeInMinutes' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'remindMeInMinutes' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'remindmeAtEpochTs' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'remindmeAtEpochTs' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'remindMeDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...remindMeDisplayFieldsFragmentDoc.definitions,
    ],
};
export const updateUiPrefsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'updateUIPrefs' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'uiPrefs' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UIPrefInput' } } },
                        },
                    },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateUIPrefs' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'uiPrefs' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'uiPrefs' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const updateUserDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'updateUser' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'initials' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'avatarImgUrl' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateUser' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'uri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'uri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'firstName' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'lastName' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'initials' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'initials' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'avatarImgUrl' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'avatarImgUrl' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'userDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...userDisplayFieldsFragmentDoc.definitions,
    ],
};
export const updateUserLoginTsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'updateUserLoginTs' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateUserLoginTs' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const updateUserSidebarCollapseStateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'updateUserSidebarCollapseState' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'sidebarCollapseState' } },
                    type: {
                        kind: 'NonNullType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'SidebarCollapseStateInput' } },
                    },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'updateUserSidebarCollapseState' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'sidebarCollapseState' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'sidebarCollapseState' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const userDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'user' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'userDisplayFields' }, directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'teamProduct' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'metadata' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastLoginTs' }, arguments: [], directives: [] },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'firstClientPortalLoginTs' },
                                                arguments: [],
                                                directives: [],
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...userDisplayFieldsFragmentDoc.definitions,
    ],
};
export const userActiveRemindMesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'userActiveRemindMes' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userActiveRemindMes' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'remindMeDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...remindMeDisplayFieldsFragmentDoc.definitions,
    ],
};
export const userOpenedBlobRefDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'userOpenedBlobRef' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'blobRefUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userOpenedBlobRef' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'blobRefUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'blobRefUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'requestTimestamp' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const userOpenedEventDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'userOpenedEvent' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userOpenedEvent' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'eventUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'requestTimestamp' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const userOpenedIntakeDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'userOpenedIntake' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'intakeId' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userOpenedIntake' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'intakeId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'intakeId' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'requestTimestamp' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const userOpenedMatterInvoiceDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'userOpenedMatterInvoice' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'matterUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userOpenedMatterInvoice' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'matterUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'matterUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'requestTimestamp' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const userRecentConversationUrisDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'userRecentConversationUris' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userRecentConversationUris' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'userRecentConversationDisplayFields' },
                                    directives: [],
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...userRecentConversationDisplayFieldsFragmentDoc.definitions,
    ],
};
export const userRecentConversationUrisUpdateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'userRecentConversationUrisUpdate' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userRecentConversationUrisUpdate' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'userRecentConversationDisplayFields' },
                                    directives: [],
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...userRecentConversationDisplayFieldsFragmentDoc.definitions,
    ],
};
export const userToggleTodoDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'userToggleTodo' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'taskUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'taskType' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'isDone' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userToggleTodo' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'taskUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'taskUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'taskType' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'taskType' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'isDone' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'isDone' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'operationId' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'requestTimestamp' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const userUnreadConversationUrisDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'userUnreadConversationUris' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userUnreadConversationUris' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'conversationUris' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const userUnreadConversationUrisUpdateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'userUnreadConversationUrisUpdate' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userUnreadConversationUrisUpdate' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'conversationUris' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const userUpdateDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'subscription',
            name: { kind: 'Name', value: 'userUpdate' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userUpdate' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'userDisplayFields' }, directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...userDisplayFieldsFragmentDoc.definitions,
    ],
};
export const doneTasksDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'doneTasks' },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'doneTasks' },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'taskUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'taskType' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'doneTs' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const fusionContactsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'fusionContacts' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'contactIds' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'ListType',
                            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                        },
                    },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fusionContacts' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'contactIds' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'contactIds' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'company' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'isDeleted' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'groupOfPeople' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' }, arguments: [], directives: [] },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'people' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' }, arguments: [], directives: [] },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'href' }, arguments: [], directives: [] },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'rel' }, arguments: [], directives: [] },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'residentialAddress' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'city' }, arguments: [], directives: [] },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'state' }, arguments: [], directives: [] },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'zipCode' }, arguments: [], directives: [] },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'country' }, arguments: [], directives: [] },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'person' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'birthdate' }, arguments: [], directives: [] },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'cell' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'number' }, arguments: [], directives: [] },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'areaCode' }, arguments: [], directives: [] },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'email' }, arguments: [], directives: [] },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'fax' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'number' }, arguments: [], directives: [] },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'areaCode' }, arguments: [], directives: [] },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' }, arguments: [], directives: [] },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'phone' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'number' }, arguments: [], directives: [] },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'areaCode' }, arguments: [], directives: [] },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'phone2' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'number' }, arguments: [], directives: [] },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'areaCode' }, arguments: [], directives: [] },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'residentialAddress' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'city' }, arguments: [], directives: [] },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'state' }, arguments: [], directives: [] },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'zipCode' }, arguments: [], directives: [] },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'country' }, arguments: [], directives: [] },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'county' }, arguments: [], directives: [] },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'addressLine1' },
                                                            arguments: [],
                                                            directives: [],
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'addressLine2' },
                                                            arguments: [],
                                                            directives: [],
                                                        },
                                                    ],
                                                },
                                            },
                                            { kind: 'Field', name: { kind: 'Name', value: 'title' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const matterRolesDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'matterRoles' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'matterUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'matterRoles' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'matterUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'matterUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'contacts' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'company' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'isDeleted' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastUpdated' }, arguments: [], directives: [] },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'person' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'birthdate' },
                                                            arguments: [],
                                                            directives: [],
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'cell' },
                                                            arguments: [],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'number' },
                                                                        arguments: [],
                                                                        directives: [],
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'areaCode' },
                                                                        arguments: [],
                                                                        directives: [],
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'email' }, arguments: [], directives: [] },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'fax' },
                                                            arguments: [],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'number' },
                                                                        arguments: [],
                                                                        directives: [],
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'areaCode' },
                                                                        arguments: [],
                                                                        directives: [],
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'firstName' },
                                                            arguments: [],
                                                            directives: [],
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' }, arguments: [], directives: [] },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'phone' },
                                                            arguments: [],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'number' },
                                                                        arguments: [],
                                                                        directives: [],
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'areaCode' },
                                                                        arguments: [],
                                                                        directives: [],
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'phone2' },
                                                            arguments: [],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'number' },
                                                                        arguments: [],
                                                                        directives: [],
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'areaCode' },
                                                                        arguments: [],
                                                                        directives: [],
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'residentialAddress' },
                                                            arguments: [],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'city' },
                                                                        arguments: [],
                                                                        directives: [],
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'state' },
                                                                        arguments: [],
                                                                        directives: [],
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'zipCode' },
                                                                        arguments: [],
                                                                        directives: [],
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'country' },
                                                                        arguments: [],
                                                                        directives: [],
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'county' },
                                                                        arguments: [],
                                                                        directives: [],
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'addressLine1' },
                                                                        arguments: [],
                                                                        directives: [],
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'addressLine2' },
                                                                        arguments: [],
                                                                        directives: [],
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'title' }, arguments: [], directives: [] },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'roles' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'contactId' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'id' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'isClient' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'isOtherSide' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'name' }, arguments: [], directives: [] },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'relationships' },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        { kind: 'Field', name: { kind: 'Name', value: 'id' }, arguments: [], directives: [] },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'contactId' },
                                                            arguments: [],
                                                            directives: [],
                                                        },
                                                        { kind: 'Field', name: { kind: 'Name', value: 'name' }, arguments: [], directives: [] },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export const messageBlobsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'messageBlobs' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'messageBlobs' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'messageUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'messageUri' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'conversationUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'conversationUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'folderBlobs' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'messageBlobRefDisplayFields' },
                                                directives: [],
                                            },
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'messageBlobRefCommentsFields' },
                                                directives: [],
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'blobs' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'messageBlobRefDisplayFields' },
                                                directives: [],
                                            },
                                            {
                                                kind: 'FragmentSpread',
                                                name: { kind: 'Name', value: 'messageBlobRefCommentsFields' },
                                                directives: [],
                                            },
                                        ],
                                    },
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'blobCountWithFolders' }, arguments: [], directives: [] },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sender' },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'uri' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' }, arguments: [], directives: [] },
                                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' }, arguments: [], directives: [] },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
        ...messageBlobRefDisplayFieldsFragmentDoc.definitions,
        ...messageBlobRefCommentsFieldsFragmentDoc.definitions,
    ],
};
export const portalUnreadBlobRefsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'portalUnreadBlobRefs' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                    type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
                    directives: [],
                },
            ],
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'portalUnreadBlobRefs' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'teamUri' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'teamUri' } },
                            },
                        ],
                        directives: [],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'portalBlobRefDisplayFields' },
                                    directives: [],
                                },
                                { kind: 'Field', name: { kind: 'Name', value: 'conversationUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'creationTimestamp' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'lastEvaluatedKey' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'openedTs' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'senderUri' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'unread' }, arguments: [], directives: [] },
                                { kind: 'Field', name: { kind: 'Name', value: 'pinTs' }, arguments: [], directives: [] },
                            ],
                        },
                    },
                ],
            },
        },
        ...portalBlobRefDisplayFieldsFragmentDoc.definitions,
    ],
};
